export default __webpack_public_path__ + "static/media/parent_slide_student_three.d2d4f668.png";